import { useEffect, useState } from "react";

const ReadingProgress = () => {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const doc = document.documentElement;
      const winH = window.innerHeight;
      const fullH = doc.scrollHeight - winH;
      const p = fullH > 0 ? Math.min(100, Math.max(0, (window.scrollY / fullH) * 100)) : 0;
      setPct(p);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <div
      data-testid="reading-progress-bar"
      role="progressbar"
      aria-valuenow={Math.round(pct)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label="Article reading progress"
      className="fixed top-0 left-0 right-0 z-[60] h-[3px] bg-transparent pointer-events-none"
    >
      <div
        className="h-full bg-brand-teal transition-[width] duration-150"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
};

export default ReadingProgress;
